// Module
var code = "<a class=\"btn blue-sharp subFormControl add-btn\" id=\"addButton\"> <i class=\"fa fa-plus-circle\"></i><span data-bind=\"text: _labels.ADD\"></span> </a>";
// Exports
export default code;